import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { sequences as sequencesApi } from 'util/Api/customer';
import {
  addFacebookMapping,
  updateFacebookMapping,
  removeFacebookMapping,
} from 'util/Api/facebook';

export const saveFacebookName = createAction('facebook/saveFacebookName');

export const saveFacebookPages = createAction('facebook/saveFacebookPages');

export const facebookLogin = createAction('facebook/login');

export const resetFacebookPages = createAction('facebook/resetFacebookPages');

export const setSelectedPage = createAction('facebook/setSelectedPage');

export const setDeletePage = createAction('facebook/setDeletePage');

export const resetRefreshFacebookStatus = createAction('facebook/resetRefreshFacebookStatus');

export const facebookSequences = createAsyncThunk(
  'facebook/sequences',
  async ({ filter }, { rejectWithValue }) => {
    try {
      return await sequencesApi({ filter });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addFacebook = createAsyncThunk(
  'facebook/ariMapping',
  async ({ facebookToken, pageId, sequenceId }, { rejectWithValue }) => {
    try {
      return await addFacebookMapping({ facebookToken, pageId, sequenceId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const updateFacebook = createAsyncThunk(
  'facebook/updateAriMapping',
  async ({ mappingId, sequenceId }, { rejectWithValue }) => {
    try {
      return await updateFacebookMapping({ mappingId, sequenceId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const refreshFacebook = createAsyncThunk(
  'facebook/refreshMapping',
  async ({ mappingId, sequenceId, facebookToken }, { rejectWithValue }) => {
    try {
      return await updateFacebookMapping({ mappingId, sequenceId, facebookToken });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const removeFacebook = createAsyncThunk(
  'facebook/removeConnection',
  async ({ mappingId }, { rejectWithValue }) => {
    try {
      return await removeFacebookMapping({ mappingId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
